import React, { useContext, useState, useRef, Fragment } from 'react';
import { AuthContext } from '../../../context/auth';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { Dropdown, Modal } from 'react-bootstrap';
import MediaQuery from 'react-responsive';
import { ReactSVG } from 'react-svg';
import { isMobileOnly } from 'react-device-detect';
import classnames from 'classnames';

import isEmpty from '../../../validation/is-empty';
import { useOnClickOutside } from './helper';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBell,
  faUserCircle,
  faSignOutAlt,
  faCog,
} from '@fortawesome/pro-regular-svg-icons';
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons';

import Burger from './burger/Burger';
import SideNav from './side-nav/SideNav';

import './Navbar.scss';
library.add(faBell, faUserCircle, faSignOutAlt, faAngleDown, faCog);

function Navbar({ showNavbar, sideNavFixed }) {
  const { user, logout } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [sessionMenu, setSessionMenu] = useState(false);
  const history = useHistory();
  const { pathname } = useLocation();
  const sidenav = useRef();
  const lastname = !isEmpty(user) ? user.lastnames.split(' ') : '';
  const fullName = !isEmpty(lastname)
    ? lastname[0].length < 3
      ? `${user.shortName} ${lastname[0]} ${lastname[1]}`
      : `${user.shortName} ${lastname[0]}`
    : '';

  useOnClickOutside(sidenav, () => {
    if (!sideNavFixed) setOpen(false);
  });

  if (isEmpty(user) || !showNavbar || pathname === '/spdm/facturacion') {
    return null;
  } else {
    const { shortName } = user;

    return (
      <nav id="_navbar_" className="navbar fixed-top">
        <div className="container">
          <div className="row no-margin">
            <div className="col-first">
              <MediaQuery minWidth={1280}>
                <ReactSVG
                  wrapper="span"
                  className="logo"
                  src="/assets/img/facti-new-logo (blue).svg"
                  fallback={() => <span>Facti - logo</span>}
                  afterInjection={(error, svg) => {
                    if (error) return;
                    svg.removeAttribute('data-src');
                  }}
                  onClick={() => {
                    history.push('/dashboard');
                  }}
                />
              </MediaQuery>
            </div>
            <div className="col-second">
              <div className="row no-margin">
                <MediaQuery maxWidth={1279}>
                  {(matches) =>
                    matches && (
                      <Fragment>
                        <ReactSVG
                          wrapper="span"
                          className="logo"
                          src="/assets/img/facti-new-logo (blue).svg"
                          fallback={() => <span>Facti - logo</span>}
                          afterInjection={(error, svg) => {
                            if (error) {
                              console.error(error);
                              return;
                            }
                            svg.removeAttribute('data-src');
                          }}
                          onClick={() => {
                            history.push('/dashboard');
                          }}
                        />
                      </Fragment>
                    )
                  }
                </MediaQuery>
              </div>
            </div>
            <div className="col-third">
              <div className="row no-margin">
                {!isMobileOnly ? (
                  <ul className="ul-session">
                    <li className="nav-item">
                      <div
                        style={{
                          height: '43px',
                          width: '43px',
                          marginTop: '7px',
                          textAlign: 'center',
                        }}
                      >
                        <Link className="btn btn-icon" to="/notifications">
                          <FontAwesomeIcon
                            style={{
                              fontSize: '20px',
                            }}
                            icon={['far', 'bell']}
                          />
                        </Link>
                      </div>
                    </li>
                    <li className="nav-item dropdown">
                      <Dropdown id="profile-session" alignRight>
                        <Dropdown.Toggle
                          id="navbarDropdown"
                          className="nav-link"
                        >
                          <div className="row no-margin">
                            <div id="avatar">
                              <img src={user.avatar} alt={user.shortName} />
                              <span id="status" />
                            </div>
                            <div id="user">
                              {shortName}
                              <FontAwesomeIcon icon={['fas', 'angle-down']} />
                            </div>
                          </div>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <div id="profile-box">
                            <img
                              id="avatar"
                              src={user.avatar}
                              alt={`Profile Avatar for ${user.email}`}
                            />
                            <div id="user-name">
                              <div className="row no-margin">
                                <div id="fullname">{fullName}</div>
                                <div id="email">{user.email}</div>
                              </div>
                            </div>
                          </div>
                          <div className="divider" />
                          <ul id="list-options">
                            <Dropdown.Item
                              onClick={() => history.push('/profile')}
                            >
                              <FontAwesomeIcon icon={['far', 'user-circle']} />{' '}
                              Mi Perfil
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={() => history.push('/settings')}
                            >
                              <FontAwesomeIcon icon={['far', 'cog']} />{' '}
                              Configuración
                            </Dropdown.Item>
                          </ul>
                          <div className="divider" />
                          <ul id="secondary-options">
                            <Dropdown.Item id="logout" onClick={logout}>
                              <FontAwesomeIcon icon={['far', 'sign-out-alt']} />
                              Cerrar Sesión
                            </Dropdown.Item>
                          </ul>
                        </Dropdown.Menu>
                      </Dropdown>
                    </li>
                  </ul>
                ) : (
                  <div
                    id="mobile-session"
                    onClick={() => setSessionMenu(!sessionMenu)}
                    className={classnames(null, {
                      open: sessionMenu,
                    })}
                  >
                    <div id="avatar">
                      <img src={user.avatar} alt={user.names} />
                      <span id="sess-status" />
                    </div>
                    <Modal
                      className="_session-modal_"
                      show={sessionMenu}
                      onHide={() => setSessionMenu(!sessionMenu)}
                      // animation={false}
                      backdropClassName="_session-backdrop_"
                    >
                      <Modal.Body>
                        <div id="profile-box">
                          <img
                            id="avatar"
                            src={user.avatar}
                            alt={`Profile Avatar for ${user.email}`}
                          />
                          <div id="user-name">
                            <div className="row no-margin">
                              <div id="fullname">{fullName}</div>
                              <div id="email">{user.email}</div>
                            </div>
                          </div>
                        </div>
                        <div className="divider" />
                        <ul id="list-options">
                          <Dropdown.Item
                            style={{ marginBottom: '10px' }}
                            onClick={() => history.push('/profile')}
                          >
                            <FontAwesomeIcon icon={['far', 'user-circle']} /> Mi
                            Perfil
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={() => history.push('/settings')}
                          >
                            <FontAwesomeIcon icon={['far', 'cog']} />{' '}
                            Configuración
                          </Dropdown.Item>
                        </ul>
                        <div className="divider" />
                        <ul id="secondary-options">
                          <Dropdown.Item id="logout" onClick={logout}>
                            <FontAwesomeIcon icon={['far', 'sign-out-alt']} />
                            Cerrar Sesión
                          </Dropdown.Item>
                        </ul>
                      </Modal.Body>
                    </Modal>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div id="sidenav-container" ref={sidenav}>
          <MediaQuery maxWidth={1279}>
            <Burger open={open} setOpen={setOpen} />
          </MediaQuery>
          <SideNav open={open} setOpen={setOpen} sideNavFixed={sideNavFixed} />
        </div>
      </nav>
    );
  }
}

export default Navbar;
